//@ts-check
import { createStore, combineReducers } from 'redux';
import { enableBatching } from 'redux-batched-actions';
import dialog from '@/common/components/kf-dialog';
import loader from '@/common/components/kf-loader';
import appReducer from './app/app.reducer';
import resultReducer from './result/result.reducer';
import staffLoginReducer from './staff-login/staff-login.reducer';

const devTool = APP_DEBUG && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f;
const reducers = combineReducers({
  loader,
  dialog,
  app: appReducer,
  result: resultReducer,
  staffLogin: staffLoginReducer
});

/** @type {import('redux').Store} */
const store = createStore(
  enableBatching(reducers),
  devTool
);

export default store;